import type { Team } from "@/types";

export function isNotAuditor(team: Team, userId: number): boolean {
  return team.users.includes(userId) && !team.auditors.includes(userId);
}

export function isAuditor(team: Team, userId: number): boolean {
  return (
    team.users.includes(userId) &&
    team.auditors.includes(userId) &&
    !team.admins.includes(userId)
  );
}
